import logoStation from './assets/imgs/logo-station.png';
import logoAddon from './assets/imgs/logo-addon.png';

// Build-time product variant. Selected via the REACT_APP_VARIANT environment
// variable (see package.json build scripts / .env.* files). Defaults to the
// CtrlStation product when unset.
const VARIANT = process.env.REACT_APP_VARIANT || 'station';

const variants = {
  station: {
    name: 'station',
    primaryColor: '#004867',
    secondaryColor: '#ff5958',
    logo: logoStation,
    features: {
      // Menu
      menuTerms: true,
      // Settings fields
      protectedAccountMode: false,
      autoSyncUserUpdate: false,
      removeExpired: false,
      logoffNotificationTimeout: false,
      activityTracking: true,
      globalBlockDisable: true,
    },
  },
  addon: {
    name: 'addon',
    primaryColor: '#0E2C4E',
    secondaryColor: '#9AC838',
    logo: logoAddon,
    features: {
      // Menu
      menuTerms: false,
      // Settings fields
      protectedAccountMode: true,
      autoSyncUserUpdate: true,
      removeExpired: true,
      logoffNotificationTimeout: true,
      activityTracking: false,
      globalBlockDisable: false,
    },
  },
};

const variant = variants[VARIANT] || variants.station;

// App version label, e.g. "1.190.0-station". Version comes from package.json
// (injected as REACT_APP_VERSION by craco.config.js).
export const versionLabel = `${process.env.REACT_APP_VERSION || ''}-${variant.name}`;

export default variant;
